export default __webpack_public_path__ + "static/media/pv-7.8e5967b0.png";